module.exports = __webpack_public_path__ + "img/logo_clipper.68353fc6.png";